import TeacherSignup from './TeacherSignup.page';

export default TeacherSignup;